import { FC } from "react"
import React, { useEffect, useState, useMemo } from "react";
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { KTSVG } from "../../../smallnation/helpers"
import services from "../../modules/services/services"
import { Pagination } from "../../modules/utility/Pagination"
//import { useSearchParams } from 'react-router-dom'
import moment from "moment"
//import { useNavigate,useParams,useLocation,useHistory } from "react-router-dom";
import { useLocation, useHistory } from "react-router-dom";
//import {  BrowserRouter as Router, Link,  useLocation} from "react-router-dom";
import { ErrorMessage } from "@hookform/error-message";
import { set, useForm } from "react-hook-form";
import $ from 'jquery';
//import { useNavigate } from 'react-router-dom';
//import { CKEditor } from '@ckeditor/ckeditor5-react';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import SunEditor, { buttonList } from "suneditor-react";
import 'suneditor/dist/css/suneditor.min.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import AsyncSelect from "react-select/async";
import makeAnimated from "react-select/animated";
//import { TablesWidget10, TablesWidget5,TablesWidget1, TablesWidget2,TablesWidget3,TablesWidget4,TablesWidget6,TablesWidget7,TablesWidget8,TablesWidget9,TablesWidget11,TablesWidget12,TablesWidget13  } from "../../../smallnation/partials/widgets"
//import { ProfileDirectoryInc } from "../../../smallnation/partials/widgets/tables/profileDirectoryInc"


const CreateEvent: FC = () => {
  const intl = useIntl()

  const [currentPage, setCurrentPage] = useState(1);
  const ITEMS_PER_PAGE = 10; // Per page show the data pagination
  const Pagesize = 10;
  const red = "red";
  const [totalItems, setTotalItems] = useState(0);
  const [totalpages, settotalPages] = useState(0);
  const [adminProfileList, setAdminProfileList] = useState([]);
  const [eventList, setEventList] = useState([]);
  const [eventInfo, setEventInfo] = useState([]);
  const siteId = '2';
  const location99 = useLocation();
  const [categories, setCategories] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [setCompanylist, setCompanies] = useState([]);

  const [eventDate, setEventDate] = useState(new Date());
  let history = useHistory();
  const [companyList, setCompanyListEvent] = useState([]);
  const [eventtypeslist, setEventTypes] = useState([]);
  const [query, setQuery] = useState("");
  const [sourceCompanyId, setSourceCompanyId] = useState<any>('');

  //const queryParams99 = new URLSearchParams(location99.search);
  //const evetnId = queryParams99.get('eventId');
  const eventId = '5';
  const [ckeventInfo, setckEventInfo] = useState<any>('');
  const {
    register,
    formState: { errors },
    handleSubmit
  } = useForm({
    criteriaMode: "all", mode: "onBlur"
  });

  function handleChangeEventDesc(content) {
    setckEventInfo(content);
  }

  function handleImageUploadBefore(files: any, info: object, uploadHandler: Function) {
    var reader1 = new FileReader();
    reader1.readAsDataURL(files[0]);
    reader1.onload = function () {
      var rdt1: any = reader1.result;
      var base64result_banner = rdt1.split(',')[1];
      var bname = files[0].name;
      var bextn = bname.split(".").pop();
      var bannerActName = bname.split(".")[0];
      var fileext_banner = bextn;

      const requestObject = {
        //"imageName": files[0].name,
        "imageName": bannerActName,
        "imageExtension": fileext_banner,
        "imageByteString": base64result_banner
      };
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          //'Authorization': "Bearer "+accessTokenIn 
          //'Authorization': accessTokenIn 
        },
        body: JSON.stringify(requestObject)
      };

      services.fileUploadS3URL(requestOptions).then((res) => {       
        const response = {
          // The response must have a "result" array.
          "result": [
            {
              "url": res.url,
              "temp": files[0],
              "name": bannerActName,
              "size": files[0].size              
            },
          ]
        }
        uploadHandler(response);

      });
    };

  }

  function validateCheck() {
    const checked = $('input[name="categoryindustry"]:checked').length;
    //alert(checked);
    if (checked >= 3) {
      $('input[name="categoryindustry"]').not(':checked').prop('disabled', true);
    } else {
      $('input[name="categoryindustry"]').prop('disabled', false);
    }
  }

  const submitValue = () => {
    var categoriesArray = [];

    $.each($("input[name='categoryindustry']:checked"), function () {
      categoriesArray.push($(this).val());
    });

    var validateEditorTxt = 1;
    if ($('#event_title').val() == "") {
      $("#eventtitleValidMsg").show();
      $(window).scrollTop($('#eventtitleValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#eventtitleValidMsg").hide();
    }

    if ($('#eventdatesel').val() == "") {
      $("#eventdateValidMsg").show();
      $(window).scrollTop($('#eventdateValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#eventdateValidMsg").hide();
    }




    if (ckeventInfo == "") {
      $("#eventInfoValidMsg").show();
      $(window).scrollTop($('#eventInfoValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#eventInfoValidMsg").hide();
    }
    if (validateEditorTxt == 0) {
      return false;
    }

    var industriesArray = [];
    $.each($("input[name='categoryindustry']:checked"), function () {
      if ($(this).is(':checked')) {
        industriesArray.push($(this).val());
      }
    });
    const requestObject = {
      "siteId": 2,
      //"countyId": 2,
      "companyId": sourceCompanyId.companyId,
      "eventTitle": $('#event_title').val(),
      "eventDate": eventDate,
      "eventAddress": $('#event_address').val(),
      "eventCity": $('#event_city').val(),
      "eventState": $('#event_state').val(),
      "eventZip": $('#postalcode').val(),
      //"eventInformation" : $('#event_information').val(),
      "eventDescription": ckeventInfo,
      "eventExternalLink": $('#event_link').val(),
      "eventTypeId": $('#event_type').val(),
      "eventStatus": "published",
      "showEventInCalendar": $('#showon').val(),
      "eventIndustry": industriesArray,

    }
    console.log(requestObject);
    var accessTokenIn = sessionStorage.getItem("adminAccToken");
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        //'Authorization': "Bearer "+accessTokenIn 
        //'Authorization': accessTokenIn 
      },
      body: JSON.stringify(requestObject)
    };

    services.adminaddEvent(requestOptions).then((res) => {
      if (res.code == '200') {
        $("#addeventsuccessMessage").fadeTo(2000, 500).slideUp(500, function () {
          $("#addeventsuccessMessage").slideUp(500);
        });
        setTimeout(() => {
          history.push('/eventlist');
        }, 1000);
      }
      else {
        $("#addeventfailMessage").fadeTo(2000, 500).slideUp(500, function () {
          $("#addeventfailMessage").slideUp(500);
        });
        setTimeout(() => {

        }, 1000);
      }
    });

  }


  function getIndustries() {
    services.getIndustryData().then((res) => {
      //console.log(JSON.stringify(res));  
      if (res.data) {
        setCategories(res.data.content);
      }
    });
  }
  function getIndustryById() {
    const requestObject = {
      "catId": "2"
    };
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        //'Authorization': "Bearer "+accessTokenIn 
        //'Authorization': accessTokenIn 
      },
      body: JSON.stringify(requestObject)
    };

    services.getIndustryCatById(requestOptions).then((res) => {
      //console.log(JSON.stringify(res));
      // navigate('/thankyou');
    });


  }
  function setCompany() {
    var company = sourceCompanyId.companyId;
    services.getCompanybyAlpha(company).then((res) => {
      console.log(JSON.stringify(res));
      if (res.data) {
        setCompanies(res.data);
      }
    });
  }
  function getAdminProfilesList() {
    var searchTxt = "";//$('#search_input').val();
    var statuschk = 'published';
    var sortBy = '';
    var sortDir = '';
    var itemsPerPage = '15000';
    var pageNumberV = '1';
    var siteIdv = '2'
    //alert("309")
    services.adminGetCompanyList(siteIdv, itemsPerPage, pageNumberV, searchTxt, statuschk, sortBy, sortDir).then((res) => {
      //console.log("#######################");
      // console.log(JSON.stringify(res));
      //alert("314")
      if (res.data) {
        console.log(JSON.stringify(res));

        setCompanyListEvent(res.data.content);
      }


    });
  }

  const animatedComponents = makeAnimated();
  const loadOptionsSource = (query, callback) => {
    // return fetch(`https://wagesurvey.hometownopportunity.com/api/jobSugList?title=${query}`).then((res) => res.json());
    var statuschk = 'published';
    var sortBy = '';
    var sortDir = '';
    var pageSize = '1000';
    var pageNumber = '1';
    var siteId = '2'

    var queryval = query;
    var encoded_queryval = encodeURIComponent(queryval)

    var endpoint = process.env.REACT_APP_AWS_API + `adminGetCompanyList?siteId=` + siteId + `&status=` + statuschk + `&pageNumber=` + pageNumber + `&pageSize=` + pageSize + `&sortBy=` + sortBy + `&sortDir=` + sortDir + `&title=&searchTxt=` + encoded_queryval;

    fetch(endpoint).then(response => {
      response.json().then(data => {
        //console.log("202-->"+JSON.stringify(data));
        const results = data.content;
        //console.log(data.content);
        callback(results);
      });
    });

  };

  const handleChangecompany = (selectedOption) => {
    console.log(selectedOption);
  }

  function getEventTypesList() {

    services.adminGetEventTypesList().then((res) => {
      console.log("#######################");
      console.log(JSON.stringify(res));
      //alert("314")
      if (res.data) {
        console.log(JSON.stringify(res));

        setEventTypes(res.data);
      }

    });
  }

  function triggerdateclick() {
    $('#eventdatesel').click();
  }

  useEffect(() => {
    getIndustryById();
    getEventTypesList();
    $("#eventInfoValidMsg").hide();
    $(".se-dialog-tabs").hide();
    $("#eventtitleValidMsg").hide();
    $("#eventdateValidMsg").hide();
    $("#addeventsuccessMessage").hide();
    $('#addeventfailMessage').hide();
    $('#eventaddressValidMsg').hide();
    getAdminProfilesList();
    getIndustries();
    var statesJson = [{ "stateId": 4, "stateName": "Alabama", "stateCode": "AL" }, { "stateId": 5, "stateName": "Alaska", "stateCode": "AK" }, { "stateId": 6, "stateName": "Alabama", "stateCode": "AL" }, { "stateId": 7, "stateName": "Arizona", "stateCode": "AZ" }, { "stateId": 8, "stateName": "Arkansas", "stateCode": "AR" }, { "stateId": 9, "stateName": "California", "stateCode": "CA" }, { "stateId": 10, "stateName": "Colorado", "stateCode": "CO" }, { "stateId": 11, "stateName": "Connecticut", "stateCode": "CT" }, { "stateId": 12, "stateName": "Delaware", "stateCode": "DE" }, { "stateId": 13, "stateName": "District of Columbia", "stateCode": "DC" }, { "stateId": 14, "stateName": "Florida", "stateCode": "FL" }, { "stateId": 15, "stateName": "Georgia", "stateCode": "GA" }, { "stateId": 16, "stateName": "Hawaii", "stateCode": "HI" }, { "stateId": 17, "stateName": "Idaho", "stateCode": "ID" }, { "stateId": 18, "stateName": "Illinois", "stateCode": "IL" }, { "stateId": 19, "stateName": "Indiana", "stateCode": "IN" }, { "stateId": 20, "stateName": "Iowa", "stateCode": "IA" }, { "stateId": 21, "stateName": "Kansas", "stateCode": "KS" }, { "stateId": 22, "stateName": "Kentucky", "stateCode": "KY" }, { "stateId": 23, "stateName": "Louisiana", "stateCode": "LA" }, { "stateId": 24, "stateName": "Maine", "stateCode": "ME" }, { "stateId": 25, "stateName": "Maryland", "stateCode": "MD" }, { "stateId": 26, "stateName": "Massachusetts", "stateCode": "MA" }, { "stateId": 27, "stateName": "Michigan", "stateCode": "MI" }, { "stateId": 28, "stateName": "Minnesota", "stateCode": "MN" }, { "stateId": 29, "stateName": "Mississippi", "stateCode": "MS" }, { "stateId": 30, "stateName": "Missouri", "stateCode": "MO" }, { "stateId": 31, "stateName": "Montana", "stateCode": "MT" }, { "stateId": 32, "stateName": "Nebraska", "stateCode": "NE" }, { "stateId": 33, "stateName": "Nevada", "stateCode": "NV" }, { "stateId": 34, "stateName": "New Hampshire", "stateCode": "NH" }, { "stateId": 35, "stateName": "New Jersey", "stateCode": "NJ" }, { "stateId": 36, "stateName": "New Mexico", "stateCode": "NM" }, { "stateId": 37, "stateName": "New York", "stateCode": "NY" }, { "stateId": 38, "stateName": "North Carolina", "stateCode": "NC" }, { "stateId": 39, "stateName": "North Dakota", "stateCode": "ND" }, { "stateId": 40, "stateName": "Ohio", "stateCode": "OH" }, { "stateId": 41, "stateName": "Oklahoma", "stateCode": "OK" }, { "stateId": 42, "stateName": "Oregon", "stateCode": "OR" }, { "stateId": 43, "stateName": "Pennsylvania", "stateCode": "PA" }, { "stateId": 44, "stateName": "Puerto Rico", "stateCode": "PR" }, { "stateId": 45, "stateName": "Rhode Island", "stateCode": "RI" }, { "stateId": 46, "stateName": "South Carolina", "stateCode": "SC" }, { "stateId": 47, "stateName": "South Dakota", "stateCode": "SD" }, { "stateId": 48, "stateName": "Tennessee", "stateCode": "TN" }, { "stateId": 49, "stateName": "Texas", "stateCode": "TX" }, { "stateId": 50, "stateName": "Utah", "stateCode": "UT" }, { "stateId": 51, "stateName": "Vermont", "stateCode": "VT" }, { "stateId": 52, "stateName": "Virginia", "stateCode": "VA" }, { "stateId": 53, "stateName": "Washington", "stateCode": "WA" }, { "stateId": 54, "stateName": "West Virginia", "stateCode": "WV" }, { "stateId": 55, "stateName": "Wisconsin", "stateCode": "WI" }, { "stateId": 56, "stateName": "Wyoming", "stateCode": "WY" }];
    setStateData(statesJson);
  }, []);
  type Props = {
    className: string
  }
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'Create Event' })}</PageTitle>
      <form onSubmit={handleSubmit(submitValue)}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="mb-10">

                <div className="d-flex flex-column ">
                  <label className="form-label">Event Sponsoring By</label>
                </div>

                <AsyncSelect
                  cacheOptions
                  components={animatedComponents}
                  getOptionLabel={(e: any) => e.name}
                  getOptionValue={(e) => e.companyId}
                  loadOptions={loadOptionsSource}
                  onInputChange={(value) => setQuery(value)}
                  //onChange={handleChangecompany}
                  onChange={(value) => setSourceCompanyId(value)}
                />
                {/* <select className="form-select" id="event_company" name="event_company" aria-label="Select example">
                  <option selected value="" >Select Company</option>
                  {
                    companyList.map((data, index) => (
                      <option value={data.companyId} >{data.name}</option>
                    ))}
                </select>
*/}

                {/*<input type="text" id="event_company" name="event_company" className="form-control" placeholder="" onChange={event => setCompany(event.target.value)}/>
                  <ul  className="col-md-6 mb-4">
                  {
                     setCompanylist.map((company, index) => (                                            
                           <li className="form-check form-check-custom form-check-solid"><input className="form-check-input" type="checkbox" value={company.companyId} name="company" id="company" onClick={seteventCompany}/>  <label className="form-check-label" htmlFor="defaultCheck1"> {company.name} </label></li>
                     ))
                   }
                   </ul> */}
              </div>
            </div>

            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="required form-label">Event Title</label>

                </div>
                <input type="text" id="event_title" name="event_title" className="form-control" placeholder="" />
                <div id="eventtitleValidMsg" style={{ color: red }} className="error">Event Title is required.</div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-10 position-relative">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="required form-label">Date</label>

                </div>
                <div>

                  <DatePicker className="form-control react-date-picker eventStartDateCls"
                    selected={eventDate}
                    onChange={(date) => setEventDate(date)}
                    minDate={moment().toDate()}
                    id="eventdatesel" name="eventdatesel"
                  />
                  <div onClick={triggerdateclick} style={{ position: "absolute", right: "10px", top: "36px" }}>
                    <KTSVG path='/media/icons/duotune/art/date-icon.svg' />
                  </div>
                </div>

                {/* <input type="text" id="event_date" name="event_date" className="form-control" placeholder=""  /> */}
                <div id="eventdateValidMsg" style={{ color: red }} className="error">Date is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" form-label">Type</label>

                </div>
                <select className="form-select" id="event_type" name="event_type" aria-label="Select example">
                  <option selected value="" >Select Type</option>
                  {
                    eventtypeslist.map((data1, index) => (
                      <option value={data1.eventTypeId} >{data1.eventTypeName}</option>
                    ))}
                </select>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="  form-label">Address</label>

                </div>
                <input type="text" id="event_address" name="event_address" className="form-control" placeholder="" />
                <div id="eventaddressValidMsg" style={{ color: red }} className="error">Address is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" form-label">City</label>

                </div>
                <input type="text" id="event_city" name="event_city" className="form-control" placeholder="" />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" form-label">State</label>

                </div>
                <select className="form-select" id="event_state" name="event_state" aria-label="Select example">
                  <option selected value="" >Select State</option>
                  {
                    stateData.map((state, index) => (
                      <option value={state.stateName}>{state.stateName}</option>
                    ))
                  }
                </select>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" form-label">Zipcode</label>

                </div>
                <input type="text" id="postalcode" name="postalcode" className="form-control" placeholder="" />
              </div>
            </div>

            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className="required form-label">Information</label>
                </div>
                {/*}<h1>this is FCK editor area</h1>*/}

                <SunEditor
                  setOptions={{
                    height: "400",
                    //buttonList: [['font', 'align'], ['image']]
                    buttonList: [
                      ['undo', 'redo'],
                      ['font', 'fontSize', 'formatBlock'],
                      ['paragraphStyle', 'blockquote'],
                      ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                      ['fontColor', 'hiliteColor', 'textStyle'],
                      ['removeFormat'],
                      '/', // Line break
                      ['outdent', 'indent'],
                      ['align', 'horizontalRule', 'list', 'lineHeight'],
                      ['table', 'link', 'image' /** ,'math' */], // You must add the 'katex' library at options to use the 'math' plugin.                    
                      ['fullScreen', 'showBlocks', 'codeView'],
                      ['preview'],

                      /** ['dir', 'dir_ltr', 'dir_rtl'] */ // "dir": Toggle text direction, "dir_ltr": Right to Left, "dir_rtl": Left to Right
                    ]
                    //buttonList: buttonList.complex
                    // plugins: [font] set plugins, all plugins are set by default
                    // Other option
                  }}
                  onChange={handleChangeEventDesc}
                  onImageUploadBefore={handleImageUploadBefore}
                />

                {/* <CKEditor
                 editor={ ClassicEditor }
                 config={{
                  removePlugins: ["EasyImage","ImageUpload","MediaEmbed"]
                }}
                 id="eventInfoId"                            
                 onReady={ editor => {
                     // You can store the "editor" and use when it is needed.
                     console.log( 'Editor is ready to use!', editor );
                     //editor.setData(profileDescription);
                     //editor.setData(profileDescription);
                     
                 } }
                 onChange={ ( event, editor ) => {
                     const data = editor.getData();
                     setckEventInfo(data);
                     console.log( { event, editor, data } );
                 } }
                 onBlur={ ( event, editor ) => {
                     console.log( 'Blur.', editor );
                 } }
                 onFocus={ ( event, editor ) => {
                     console.log( 'Focus.', editor );
                 } }
             /> */}
                <div id="eventInfoValidMsg" style={{ color: red }} className="error">Information is required.</div>

                {/* <textarea className="form-control textarea" placeholder="Event Information" id="event_information" name="event_information" spellcheck="false" {...register("eventinfo", {
                          required: "This field is required",
                          maxLength: { value: 2000, message: 'Should not allow more than 2000 characters' }
                        })}></textarea>
                        <ErrorMessage
                          errors={errors}
                          name="eventinfo"
                          className="invalid-feedback"
                          render={({ messages }) => {
                            console.log("messages", messages);
                            return messages
                              ? Object.entries(messages).map(([type, message]) => (
                                <p key={type} className="error">{message}</p>
                              ))
                              : null;
                          }}

                        /> */}
              </div>
            </div>

            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" form-label">More Information link</label>
                  <small className="mb-3">http://example.com</small>
                </div>
                <input type="text" id="event_link" name="event_link" className="form-control" placeholder="" />
              </div>
            </div>



            <div className="col-lg-6 d-none" >
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" form-label">Show on Calendar page</label>
                </div>
                <select className="form-select" id="showon" name="showon" aria-label="Select example">
                  <option selected value="yes">Yes</option>
                  <option value="no">No</option>

                </select>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label htmlFor="exampleFormControlInput1" className=" form-label">Industry</label>
                  <small>Max 3 Categories</small>
                  <div className="row mt-8">

                    {
                      categories.map((data, index) => (
                        <div className="col-md-6 mb-4">
                          <div className="form-check form-check-custom form-check-solid">
                            <input className="form-check-input" type="checkbox" name="categoryindustry" value={data.catId} onClick={() => validateCheck()} />
                            <label className="form-check-label" htmlFor={data.catId}>
                              {data.name}
                            </label>
                          </div>
                        </div>
                      ))}


                    <div className="divider"></div>

                    <button type="submit" className="btn btn-primary mt-10" style={{ maxWidth: "135px" }}> Create Event </button>



                  </div>
                </div>

                <div id="addeventsuccessMessage" className="alert alert-success" role="alert">Event Created Successfully</div>
                <div id="addeventfailMessage" className="alert alert-danger" role="alert">Please try again</div>

              </div>
            </div>

          </div>
        </div>
      </form>
    </>
  )
}
export { CreateEvent }